import { generaLivello } from "./utility.js";
export default function ultimoLivello(k) {
    k.scene("ultimoLivello", () => {
        const LIVELLO = [
            "",
            "",
            "                B",
            "              =====",
            "       ==             ==",
            " ",
            " ===        ==   ==       ===",
            " ",
            " @                ",
            " ==========================",
        ];
        generaLivello(k, LIVELLO, null);
    });
}